import React, { useState, useEffect, Fragment } from 'react';
import { ProductQuantityConstants } from '../constants';

const ProductQuantityField = (props) => {
    const defaultQuantity = parseInt(props.minArticleQuantity) ?? 1;

    useEffect(() => {
        document.getElementById(ProductQuantityConstants.QuantityId).value = defaultQuantity;
      }, []);

    const [quantity, setQuantity] = useState(defaultQuantity);

    const setQuantityInputField = (newValue) => {
        document.getElementById(ProductQuantityConstants.QuantityId).value = newValue;
    };

    const increaseQuantity = () => {
        setQuantity((x) => x + defaultQuantity);
        setQuantityInputField(quantity+defaultQuantity);
    };

    const decreaseQuantity = () => {
        if (quantity > defaultQuantity) {
            setQuantity((x) => x - defaultQuantity);
            setQuantityInputField(quantity-defaultQuantity);
        }
    };

    return (
        <Fragment>            
            <a  className={`${ProductQuantityConstants.ProductDetailQuantityButton} left`} 
                onClick={decreaseQuantity}>
                    {ProductQuantityConstants.MinusSign}
            </a>
            <p  id={ProductQuantityConstants.QuantityId} 
                value={defaultQuantity}
                className={ProductQuantityConstants.ProductDetailQuantityInput}>
                    {quantity}
            </p>
            <a  className={`${ProductQuantityConstants.ProductDetailQuantityButton} right`}        
                onClick={increaseQuantity}>
                    {ProductQuantityConstants.PlusSign}
            </a>
        </Fragment>
    );
};

export default ProductQuantityField;